export const SIMULATE_REVIEW_COMPLETE = false;

const CDN_FALLBACK_PREFIX = 'https://firebasestorage.googleapis.com/v0/b/designpro-325314.appspot.com/o/';

const buildImageUrl = imagePath => {
  if (!imagePath) {
    return null;
  }

  return imagePath.startsWith('http') ? imagePath : `${CDN_FALLBACK_PREFIX}${imagePath.replace(/\//g, '%2F')}?alt=media`;
};

const rawFrameImages = [
  '709bb3b3-34bc-41f3-ae95-99920d4a3ab0/mob1.png_0_20250919-003842.jpg',
];

const simulatedAuditData = {
  product: 'Review this interface for clarity issues. Identify where users might be confused about functionality, next steps, or purpose. Suggest ways to make actions more obvious.',
  category: 'ux_critique',
  review_category: 'ux_critique',
  priming_options: 'ux-critique',
  problem_tags: ['Information Overload', 'Decision Speed', 'Understanding'],
  design_images: rawFrameImages.map(buildImageUrl),
  has_tamm_guideline: false,
};

export const SIMULATED_REVIEW_DATA = {
  id: 22,
  uuid: '891241b1-f6e1-4253-8e5a-1280ea02c2d6',
  firestore_job_id: '56fa880e-1a80-4aee-8ffe-eb970d6bead5',
  title: 'Screenshots File',
  created_at: '2025-09-18T19:39:36.890793Z',
  updated_at: '2025-09-18T19:39:36.890805Z',
  review_status: 1,
  review_created_at: '2025-09-18T19:38:44.494000Z',
  review_updated_at: '2025-09-18T19:39:36.888644Z',
  feedback_added: true,
  feedback_version: 1,
  audit_data: simulatedAuditData,
  extra_data: {
    goals: '',
    template: 'UX Critique',
    file_name: 'Screenshots File',
    flow_type: 'single',
    json_path: '709bb3b3-34bc-41f3-ae95-99920d4a3ab0/20250919-003842_data_0.json',
    page_name: 'Screenshots Page',
    page_type: '',
    json_paths: [
      '709bb3b3-34bc-41f3-ae95-99920d4a3ab0/20250919-003842_data_0.json',
    ],
    frame_image: rawFrameImages[0],
    frame_images: rawFrameImages,
    user_problem: simulatedAuditData.product,
    priming_options: ['ux-critique'],
    review_frame_id: '0:0',
    generic_feedback: false,
    review_frame_ids: ['0.0'],
    review_frame_name: 'Screenshots',
    review_frame_names: ['Screenshot#1'],
    accessibility_score: null,
    accessibility_guideline_name: 'null',
    accessibility_guideline_type: 1,
  },
  final_feedback: [
    {
      id: 'feedback-information-overload',
      page: 1,
      label: 'Information Overload',
      reason: `Users encounter a tracking permission dialog that only explains the company's benefit ('measure advertising efficiency') without clarifying what value the user gains by allowing tracking, creating friction in the decision-making process.`,
      category: 'suggestion',
      node_ids: [],
      detailed_feedback: [
        'Clarify the tracking purpose beyond "advertising efficiency" by explaining specific benefits users will receive from allowing tracking.',
      ],
      psychology_insight: 'How information is presented affects decision-making, especially when users must weigh privacy concerns against unclear benefits.',
      psychology_principle: '🧠 Framing Effect',
    },
    {
      id: 'feedback-decision-speed',
      page: 1,
      label: 'Decision Speed',
      reason: `The current design presents 'Allow' as a more prominent button while 'Ask App Not to Track' appears as a secondary link, subtly steering users toward allowing tracking when they might prefer privacy if options were presented equally.`,
      category: 'error',
      node_ids: [],
      detailed_feedback: [
        `Redesign the dialog to make the 'Ask App Not to Track' option visually equal to 'Allow' by using the same button style and prominence to avoid nudging users toward tracking.`,
      ],
      psychology_insight: 'Users tend to follow the path of least resistance or the option that appears to be recommended by the interface.',
      psychology_principle: '⚖️ Default Bias',
    },
    {
      id: 'feedback-understanding',
      page: 1,
      label: 'Understanding',
      reason: `The dialog uses vague language about tracking 'activity across other companies' apps and websites' without specifying what data points will be collected, how they'll be used, or how they'll be protected, creating uncertainty that may cause anxiety or mistrust.`,
      category: 'suggestion',
      node_ids: [],
      detailed_feedback: [
        `Add a brief explanation of what specific data will be tracked and how it will be protected, rather than the vague statement about 'your activity across other companies' apps and websites.'`,
      ],
      psychology_insight: 'People tend to avoid options when they lack clear information about potential outcomes.',
      psychology_principle: '❓ Ambiguity Effect',
    },
  ],
  post_processes: [
    {
      process_type: 1,
      status: 2,
      result_data: {
        pdf_link: 'https://example.com/mock-review.pdf',
      },
    },
  ],
  project: 7,
  owner: 25,
};

const simulatedDesignImages = Array.isArray(simulatedAuditData.design_images)
  ? simulatedAuditData.design_images
  : [];

export const SIMULATED_SCREENSHOT_UPLOADS = simulatedDesignImages.map((imageUrl, index) => ({
  name: `Simulated Screen ${index + 1}`,
  uid: `simulated-${index}`,
  preview: imageUrl,
  url: imageUrl,
  progress: 100,
  isProgressLoading: false,
  isExistingImage: true,
}));

export const SIMULATED_PRODUCT_DESCRIPTION = simulatedAuditData.product;

export const SIMULATED_CATEGORY = simulatedAuditData.category;

export const SIMULATED_PROBLEM_TAGS = simulatedAuditData.problem_tags;
